//import external libraries
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { sizeOfUnitMapping } from "../../../utils/unitConstants";

//import MUI components
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";
import WavesIcon from "@mui/icons-material/Waves";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import AirIcon from "@mui/icons-material/Air";
import InputIcon from "@mui/icons-material/Input";
import useMediaQuery from "@mui/material/useMediaQuery";

function ProjectItemCardHydra({ activePosition }) {
  const [value, setValue] = useState(0);
  const theme = useTheme();

  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
  const { t } = useTranslation();

  function findUnitType(unitID) {
    if (unitID < 9) return "HYDRApro COMPACT BASIC";
    else if (unitID > 22) return "HYDRApro GENIUS";
    else return "HYDRApro BASIC";
  }

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "70%" },
        // maxWidth: { xs: "100vw", sm: "60vw" },
        // mx: "20%",
        // my: "2%",
        bgcolor: "#C4C4C4",
        borderLeft: `5px solid ${theme.palette.secondary.main}`,
        minHeight: "300px",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        <Tab
          icon={<WavesIcon />}
          label={isSmallScreen ? "" : t("hydraPro.mainData")}
        />
        <Tab
          icon={<ThermostatIcon />}
          label={isSmallScreen ? "" : t("hydraPro.thermodynamicParams")}
        />
        {/* <Tab label={t("hydraPro.pressures")} />
            <Tab label={t("hydraPro.absHum")} />
            <Tab label={t("hydraPro.attractions")} />
            <Tab label={t("hydraPro.maxAmountCalc")} />*/}
        <Tab
          icon={<AirIcon />}
          label={isSmallScreen ? "" : t("hydraPro.maxAirVol")}
        />
        <Tab
          icon={<InputIcon />}
          label={isSmallScreen ? "" : t("hydraPro.ahuSelectionSize")}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.posName")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.name}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.poolName")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.poolName}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.poolType")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.typeOfPool}
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.poolVolume")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.poolVolume} m<sup>3</sup>
            </Typography>
          </Grid>
          <Grid item xs={6} md={12}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.waterSurface")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.waterSurface} m<sup>2</sup>
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.airTemp")}
            </Typography>

            <Typography variant="body1" component="div">
              {activePosition.airTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.waterTemp")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.waterTemperature} °C
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.airHumid")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.airHumidity} %
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.maxRequiredAir")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.maxRequiredAir}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.minRequiredFreshAir")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.minRequiredFreshAir}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.numOfAirChanges")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.numOfAirChanges}
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.unitType")}
            </Typography>
            <Typography variant="body1" component="div">
              {findUnitType(activePosition.unitTypeId)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.unitSize")}
            </Typography>
            <Typography variant="body1" component="div">
              {sizeOfUnitMapping[activePosition.unitTypeId]}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.numberOfUnits")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.numOfUnits} pcs
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {t("hydraPro.price")}
            </Typography>
            <Typography variant="body1" component="div">
              {activePosition.price} €
            </Typography>
          </Grid>
        </Grid>
      </TabPanel>
    </Box>
  );
}

export default ProjectItemCardHydra;
